/**
 * SSOT Magnet URI factory — the ONLY place magnet URIs are constructed.
 * All other code MUST import and use this function.
 */
export interface MagnetUriOptions {
  infoHash: string;
  displayName?: string;
  trackers?: string[];
}

export function buildMagnetUri(opts: MagnetUriOptions): string {
  const params = new URLSearchParams();
  params.set('xt', `urn:btih:${opts.infoHash}`);
  if (opts.displayName) params.set('dn', opts.displayName);
  if (opts.trackers) {
    for (const tr of opts.trackers) params.append('tr', tr);
  }
  return `magnet:?${params.toString()}`;
}
